import React from 'react'
import { IAdmissionRowSlots, IHealthProcedures, TimelinePeriodTypes } from '~/interfaces'
import { TimelineRectangleButton } from '~/components/shared'
import { createAdmissionsStructure } from '~/utils'

export interface TimelineConductsProps {
  variant?: 'conduct' | 'diagnosis'
  healthProcedures: IAdmissionRowSlots[] | IHealthProcedures[]
  period: TimelinePeriodTypes
  handleClick: (omics: IAdmissionRowSlots[]) => void
}

export const TimelineConducts = ({
  variant = 'conduct',
  healthProcedures,
  period,
  handleClick
}: TimelineConductsProps): JSX.Element => {
  const positionedConducts = createAdmissionsStructure({
    admissions: healthProcedures as IAdmissionRowSlots[],
    mode: period
  })

  return (
    <>
      {positionedConducts.map(conduct => {
        return (
          <TimelineRectangleButton
            key={conduct.id}
            variant={variant}
            onClick={handleClick}
            healthProcedures={[conduct]}
            position={conduct.percentagePosition}
            rowSize={conduct.width}
          />
        )
      })}
    </>
  )
}
